import { useState } from "react";
import time1 from "../../assets/images/time1.webp";
import time2 from "../../assets/images/time2.webp";
import calen from "../../assets/images/calen.svg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import location_01 from "../../assets/images/location_1.svg";
import time3 from "../../assets/images/time3.webp";
import time4 from "../../assets/images/time4.webp";

export default function TimeHead() {
  const [isAlternate, setIsAlternate] = useState(false);

  const handleLeftClick = () => {
    setIsAlternate((prev) => !prev);
  };

  const handleRightClick = () => {
    setIsAlternate((prev) => !prev);
  };

  return (
    <div className="w-full relative">
      <div className="container mx-auto p-3 w-full relative">
        <div className="w-full relative">
          {/* Conditional rendering based on the isAlternate state */}
          <img
            src={isAlternate ? time2 : time1}
            alt="Mobile view"
            className="w-full h-[290px] block md:hidden lg:hidden"
          />
          <img
            src={isAlternate ? time4 : time3}
            alt="Desktop view"
            className="w-full h-auto hidden md:block relative lg:block"
          />

          <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute top-2 left-2 z-10 flex items-center justify-center lg:top-[58px] lg:left-[74px]">
            <p className="text-[16px] font-normal text-white">Tin tức</p>
          </div>
          <div className="absolute z-10 w-[160px] h-[33px] bg-white top-32 left-2 rounded-[20px] px-[16px] py-[6px] flex items-center gap-2 lg:top-[366px] lg:left-[74px] ">
            <img src={calen} alt="Calendar icon" />
            <p>06 Nov 2024</p>
          </div>
          <div className="absolute z-10 left-2 top-44 lg:text-[36px] lg:font-semibold lg:top-[424px] lg:left-[74px]">
            <p className="text-white lg:w-[1144px]">
              Lorem ipsum dolor sit amet, consect adipiscing elit. In ac congue
              elit.
            </p>
          </div>
          <div className="absolute left-2 top-60 flex flex-row items-center gap-2 text-white lg:top-[551px] lg:left-[74px]">
            <img src={location_01} alt="Location icon" />
            <p>BT16B6 -32, Làng Việt Kiều Châu Âu, Mỗ Lao, Hà Đông, Hà Nội</p>
          </div>
          <div
            className="absolute z-10 left-0 right-0 -bottom-4 flex items-center justify-center gap-3 p-3 "
            id="mi"
          >
            <div
              className="w-[33px] h-[33px] bg-white flex items-center justify-center rounded-full border border-[#E2E2E2] border-solid shadow-custom cursor-pointer"
              onClick={handleLeftClick}
            >
              <FaChevronLeft />
            </div>
            <div
              className="w-[33px] h-[33px] bg-white flex items-center justify-center rounded-full border border-[#E2E2E2] border-solid shadow-custom cursor-pointer"
              onClick={handleRightClick}
            >
              <FaChevronRight />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
